<template>
    <div class="main-wrapper scroll-y custom-scrollbar with-tabs view-user-personal-data">

        <page-title :title="'Twoje dane'" :back="true"></page-title>

        <ion-list>
            <slide-x-left-transition :duration="400" :delay="200">
                <ion-item v-if="show">
                    <ion-label><h3>Imię i nazwisko</h3></ion-label>
                    <p>{{ getProfile.first_name }} {{ getProfile.last_name }}</p>
                    <ion-button mode="ios" fill="outline" size="small" @click="goTo('UserProfileBasic')">Zmień</ion-button>
                </ion-item>
            </slide-x-left-transition>
            <slide-x-left-transition :duration="500" :delay="300">
                <ion-item v-if="show">
                    <ion-label><h3>Numer telefonu</h3></ion-label>
                    <p>{{ getProfile.phone_number }}</p>
                    <ion-button mode="ios" fill="outline" size="small" @click="goTo('UserProfilePhone')">Zmień</ion-button>
                </ion-item>
            </slide-x-left-transition>
            <slide-x-left-transition :duration="600" :delay="400">
                <ion-item v-if="show">
                    <ion-label><h3>Twoje hasło</h3></ion-label>
                    <p>*********</p>
                    <ion-button mode="ios" fill="outline" size="small" @click="goTo('UserProfilePassword')">Zmień</ion-button>
                </ion-item>
            </slide-x-left-transition>
        </ion-list>

    </div>
</template>

<script>
    import PageTitle from '@/components/PageTitle.vue';
    import goTo from '@/mixins/goto';
    import { mapGetters } from 'vuex';

    export default{
        name: 'UserProfileIndex',
        components: { PageTitle },
        mixins: [goTo],
        computed: {
            ...mapGetters('profile', ['getProfile'])
        },
        data() {
            return {
                show: false
            }
        },
        mounted(){
            this.show = true;
        }
    }
</script>

<style lang="scss" scoped>
    ion-list{
        padding: 0;
        background: #f2f2f2;
    }
    ion-item{
        --background: #f2f2f2;
    }
</style>